"use client";
import { jsxs as y, jsx as u } from "react/jsx-runtime";
import { ellipsis as N } from "../../common/styles/mixins/ellipsis.js";
import { focusOutline as w } from "../../common/styles/mixins/focusOutline.js";
import R from "../icon/Icon.js";
import C from "../loader/Loader.js";
import { css as t } from "@emotion/react";
import d from "@emotion/styled";
import { darken as b } from "../../helpers/color/color.js";
import { COLORS as e } from "../../tokens/colors/Colors.js";
import { FONT_SIZES as g } from "../../tokens/font-sizes/FontSizes.js";
import { FONT_WEIGHTS as E } from "../../tokens/font-weights/FontWeights.js";
import { MOTION_DURATIONS as x } from "../../tokens/motion-durations/MotionDurations.js";
import { MOTION_EASINGS as L } from "../../tokens/motion-easings/MotionEasings.js";
import { SPACINGS as p } from "../../tokens/spacings/Spacings.js";
import { forwardRef as _, useState as h, useRef as j, useEffect as A } from "react";
const a = x.normal, O = _(
  ({ children: o, disabled: l = !1, feIcon: r, feSize: s = "md", type: i = "button", ...c }, T) => {
    const [k, $] = h(!1), [v, f] = h(!1), { feType: B = "primary" } = c, m = c.feType === "primary" && c.feLoading, n = j();
    return A(() => {
      m ? (f(!0), n.current && clearTimeout(n.current), n.current = setTimeout(() => {
        $(!0);
      }, a)) : ($(!1), n.current && clearTimeout(n.current), n.current = setTimeout(() => {
        f(!1);
      }, a));
    }, [m]), /* @__PURE__ */ y(
      D,
      {
        ...c,
        "data-comp": "button",
        disabled: l ? !!l : !!m,
        feLoading: m,
        feSize: s,
        feType: B,
        ref: T,
        type: i,
        children: [
          v && /* @__PURE__ */ u(G, { feColorInvert: !0, feLoading: k, feSize: "sm" }),
          /* @__PURE__ */ y(z, { feLoading: m, children: [
            (r == null ? void 0 : r.position) === "left" && /* @__PURE__ */ u(S, { ...r }),
            /* @__PURE__ */ u(F, { children: o }),
            (r == null ? void 0 : r.position) === "right" && /* @__PURE__ */ u(S, { ...r })
          ] })
        ]
      }
    );
  }
);
O.displayName = "Button";
const ro = O, D = d.button(
  ({ feDestructive: o, feLoading: l, feSize: r, feType: s }) => {
    const i = s === "primary" && o ? e.redBase : e.brand;
    return t`
			border-radius: 2px;
			font-weight: ${E.bold};
			max-width: min(100%, 23ch);
			padding: 0 ${p.md};
			position: relative;
			transition-duration: ${x.normal}ms;
			transition-property: background-color, color;

			&:focus-visible {
				${w()}
			}

			${!l && t`
				&:disabled,
				&:disabled:hover,
				&:disabled:active {
					background-color: ${e.gray100};
					border: 0;
					color: ${e.gray500};
				}
			`}

			${r === "md" && t`
				font-size: ${g.md};
				height: 2.75rem;
				min-width: 100px;
			`}

			${r === "sm" && t`
				font-size: ${g.sm};
				height: 2rem;
				min-width: 64px;
			`}

			${s === "primary" && t`
				background-color: ${i};
				color: ${e.white};

				&:hover {
					background-color: ${b(i, 15)};
				}

				&:active {
					background-color: ${b(i, 35)};
				}
			`}

			${s === "secondary" && t`
				background-color: ${e.white};
				border: 1px solid ${i};
				color: ${i};

				&:hover {
					background-color: ${e.gray100};
				}

				&:active {
					background-color: ${e.gray200};
				}
			`}
		`;
  }
), G = d(C)(
  ({ feLoading: o }) => t`
		left: 50%;
		opacity: ${!o && 0};
		position: absolute;
		top: 50%;
		transform: translate(-50%, -50%);
		transition: opacity ${a}ms ${L.easeIn};
		transition-delay: ${o && `${a}ms`};
	`
), z = d.span(
  ({ feLoading: o }) => t`
		align-items: center;
		display: flex;
		justify-content: center;
		opacity: ${o && 0};
		transition: opacity ${a}ms ${L.easeIn};
		transition-delay: ${!o && `${a}ms`};
	`
), F = d.span`
	${N()}
`, S = d(R)(
  ({ position: o }) => t`
		color: inherit;
		margin-inline: ${o === "right" ? p.xs : 0}
			${o === "left" ? p.xs : 0};
	`
);
export {
  ro as default
};
